import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfirmDialogService {
    private dialog = inject(MatDialog);

    async confirm(
        message: string,
        title?: string,
        confirmColor: 'primary' | 'warn' | 'accent' = 'primary',
        confirmMessage = 'Bestätigen',
        cancelMessage = 'Abbrechen',
        confirmIcon = 'innogy_picto_check',
        cancelIcon = 'innogy_picto_close',
    ) {
        return lastValueFrom(this.dialog.open(ConfirmDialogComponent, {
            data: {
                message,
                title,
                confirmMessage,
                confirmColor,
                cancelMessage,
                cancelIcon,
                confirmIcon,
            },
        }).afterClosed());
    }
}
